import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { userGroupUrlCheck, getUserTimeZone } from '../../../utils/userGroupUrlCheck';
import { URL_IMG } from '../../../configs/urlConfigs';
import { MSG_RECORDED_ADDED_SUCCESS, MSG_NOT_FOUND, MSG_RECORDED_DELETE_SUCCESS, MSG_RECORDED_UPDATED_SUCCESS, MSG_DELETE_VECHICLE_FIELD, MSG_VEHICLE_FIELD_ADD_ERROR, MSG_VEHICLE_FIELD_UPDATE_ERROR, MSG_VEHICLE_FIELD_DELETE_ERROR, MSG_VEHICLE_FIELD_DUP_ERROR } from '../../../configs/msgConfigs';
import { LBL_ACTIONS, LBL_EDIT, LBL_DELETE, LBL_BTN_ADDNEW, LBL_SLNUM, LBL_FIELD_NAME, LBL_FIELD_TYPE,  LBL_MANDATORY_FIELD, LBL_VEHICLE_INFO, LBL_APP_NAME, LBL_SETTINGS,  LBL_CONFIRM_DELETE, LBL_BACK_TO_SETTINGS, LBL_ADD_VEHICLE_FIELD, LBL_EDIT_VEHICLE_FIELD } from '../../../configs/labelConfigs';
import { DYNAMIC_FIELDS_TYPES, ROUTE_SA_SETTINGS, LOGIN_OMNU_AFFILIATE_GROUP } from '../../../configs/staticConfigs';
import ModalWindow from '../../commons/helpers/modalWindow';
import Toast from '../../commons/helpers/toast';
import { clearAction } from '../../../actions/commonActions';
import { format as stringFormat } from 'react-string-format';
import { listVehicleFieldsMasterAction, addVehicleFieldaMasterAction, updateVehicleFieldaMasterAction, deleteVehicleFieldaMasterAction } from '../../../actions/settings/superadmin/vehicleMasterInfoAction';
import { LIST_VEHICLE_FIELDS_MASTER_SUCCESS, ADD_VEHICLE_FIELDS_MASTER_SUCCESS, ADD_VEHICLE_FIELDS_MASTER_ERROR,  UPDATE_VEHICLE_FIELDS_MASTER_SUCCESS, UPDATE_VEHICLE_FIELDS_MASTER_ERROR,  DELETE_VEHICLE_FIELDS_MASTER_SUCCESS, DELETE_VEHICLE_FIELDS_MASTER_ERROR } from '../../../actions';

class VehicleMasterFields extends Component {

    constructor(props) {
        super(props)
        let timeZone = getUserTimeZone(this.props.location);
        this.state = {
            vehicleFieldsMasterList: [], 
            formErrors: {},
            infoFormErrors: {},
            commonErrMsg: '',
            valueErrMsg: '',
            fieldDetails: [],
            toastMessagePop: '',
            toastFlagPop: false,
            toastSuccessPop: true,
            vehicleInfoValue: {},
            activeRowId: 0,
            timeZone: timeZone,
            editId: 0,
            selectedField: {},
            formErrorFieldName: "",
        }

        this.modalAdd = React.createRef();
        this.modalConfirm = React.createRef(); 
        this.modalDelete = React.createRef(); 
    }

    onCloseToastPop = () => { // USED FOR POPUP clientContactAdd
        this.setState({ toastFlagPop: false, toastMessagePop: '', toastSuccessPop: false });
    }

    setToasterStatePop = (isEnabled, message, isSucces, isAutoHide = true) => {
        this.setState({ toastFlagPop: isEnabled, toastMessagePop: message, toastSuccessPop: isSucces });
        if (isAutoHide) {
            setTimeout(() => {
                this.onCloseToastPop();
            }, 3000);
        }
    }

    componentDidMount() {
        document.title = LBL_APP_NAME + " - " + LBL_SETTINGS + " -  " + LBL_VEHICLE_INFO;
        this.props.listVehicleFieldsMasterAction();
        //this.props.listVehicleMasterInfo();
    }

    componentDidUpdate(prevProps) {
        let { vehicleFieldsMasterList, vehicleFieldsMasterStatus, vehicleFieldsMasterActivity, vehicleFieldsMasterErrorData } = this.props;
        
        if ((vehicleFieldsMasterActivity !== prevProps.vehicleFieldsMasterActivity) || (vehicleFieldsMasterStatus!== prevProps.vehicleFieldsMasterStatus)) { 
            var arrResp = vehicleFieldsMasterActivity.split('~~');
            var actString = arrResp[0];
            if (actString === LIST_VEHICLE_FIELDS_MASTER_SUCCESS) {
                this.props.clearAction();
                let field_details = []
                if (vehicleFieldsMasterList.length === 0) {
                    // field_details.push({ field_id: 0, id: "", field_name: '', field_type: '', is_mandatory: false, crew_visibility: true, client_visibility: true, applicable_to:LOGIN_OMNU_AFFILIATE_GROUP, is_active: true });
                }
                else {
                    field_details = vehicleFieldsMasterList; 
                }
                this.setState({ vehicleFieldsMasterList: field_details});
            }
            else if (actString === ADD_VEHICLE_FIELDS_MASTER_SUCCESS) {
                this.props.clearAction();
                this.modalAdd.current.handleModelClose();
                this.setToasterStatePop(true, MSG_RECORDED_ADDED_SUCCESS, true);
                this.props.listVehicleFieldsMasterAction();
            } 
            else if (actString === ADD_VEHICLE_FIELDS_MASTER_ERROR) {
                this.props.clearAction();
                let errString = MSG_VEHICLE_FIELD_ADD_ERROR; 
                if(vehicleFieldsMasterErrorData?.message && vehicleFieldsMasterErrorData.message=="already_exist") {
                    this.setState({formErrorFieldName:MSG_VEHICLE_FIELD_DUP_ERROR});
                } 
                else {
                    this.setToasterStatePop(true, errString, false);
                }
            } 
            else if (actString === UPDATE_VEHICLE_FIELDS_MASTER_SUCCESS) {
                this.props.clearAction();
                this.modalAdd.current.handleModelClose();
                this.setToasterStatePop(true, MSG_RECORDED_UPDATED_SUCCESS, true);
                this.props.listVehicleFieldsMasterAction();
            }
            else if (actString === UPDATE_VEHICLE_FIELDS_MASTER_ERROR) {
                this.props.clearAction();
                let errString = MSG_VEHICLE_FIELD_UPDATE_ERROR; 
                if(vehicleFieldsMasterErrorData?.message && vehicleFieldsMasterErrorData.message=="already_exist") {
                    this.setState({formErrorFieldName:MSG_VEHICLE_FIELD_DUP_ERROR});
                } 
                else {
                    this.setToasterStatePop(true, errString, false);
                }
            }
            else if (actString === DELETE_VEHICLE_FIELDS_MASTER_SUCCESS) {
                this.props.clearAction();
                this.setToasterStatePop(true, MSG_RECORDED_DELETE_SUCCESS, true);
                this.props.listVehicleFieldsMasterAction();
            }
            else if (actString === DELETE_VEHICLE_FIELDS_MASTER_ERROR) {
                this.props.clearAction();
                this.setToasterStatePop(true, MSG_VEHICLE_FIELD_DELETE_ERROR, true);
            }
        }

    }

    addNewRow = (e) => {
        let newfieldObj = {"id":'',"field_name":'',"field_type":'',"is_mandatory":false,"crew_visibility":true,"client_visibility":true,"applicable_to":LOGIN_OMNU_AFFILIATE_GROUP,"is_active":true};
        this.setState({ selectedField: newfieldObj, formErrorFieldName: '' }, () => {
            this.modalAdd.current.handleOpenModal();
        });
    }

    editBtnClick = (e, id) =>{  
        let newfieldObj = this.state.vehicleFieldsMasterList;
        let selObj = newfieldObj.find(item => item.id==id);
        this.setState({ selectedField: selObj, formErrorFieldName: '' }, () => {
            this.modalAdd.current.handleOpenModal();
        });
    }

    deleteBtnClick = (e, id) => {
        let newfieldObj = this.state.vehicleFieldsMasterList;
        let selObj = newfieldObj.find(item => item.id==id);
        this.setState({ selectedField: selObj }, () => {
            this.modalDelete.current.handleOpenModal();
        });
    }

    onDeleteAction = () => {
        this.props.deleteVehicleFieldaMasterAction(this.state.selectedField.id);
        this.modalDelete.current.handleModelClose();
        this.setState({ selectedField: {} });
    }

    onModalFormReset = (e) => {
        // this.modalDelete.current.handleModelClose();
        this.setState({ selectedField: {} });
    }

    onHandleChange = (e, fieldIndex, fieldName) => {
        const valStr = e.target.type === "checkbox" ? e.target.checked : e.target.value;
        let fieldDetails = this.state.selectedField;

        if (fieldName === 'field_name') {
            fieldDetails.field_name = valStr;
            this.setState({ selectedField: fieldDetails });
        }
        else if (fieldName === 'field_type') {
            fieldDetails.field_type = valStr;
            this.setState({ selectedField: fieldDetails });
        }
        else if (fieldName === 'is_mandatory') {
            fieldDetails.is_mandatory = valStr;
            this.setState({ selectedField: fieldDetails });
        }
        else if (fieldName === 'crew_visibility') {
            fieldDetails.crew_visibility = valStr;
            this.setState({ selectedField: fieldDetails });
        }
        else if (fieldName === 'client_visibility') {
            fieldDetails.client_visibility = valStr;
            this.setState({ selectedField: fieldDetails });
        }
    }

    onSaveFormData = (e) => {
        let fieldDetails = this.state.selectedField;

        if(fieldDetails.field_name.trim()==='') {
            return false; 
        }
        else if(fieldDetails.field_type.trim()==='') {
            return false; 
        }

        if(!fieldDetails.id) {
            this.props.addVehicleFieldaMasterAction(fieldDetails); 
        }
        else {
            this.props.updateVehicleFieldaMasterAction(fieldDetails); 
        }
    }

    onShowActionButtons = (event, rowId) => {
        let dropdown = document.getElementById('dropdown-' + rowId);
        let dropdownMenu = document.getElementById('dropdown-menu-' + rowId);
        dropdown.classList.toggle('show');
        dropdownMenu.classList.toggle('show');

        if (this.state.activeRowId === 0) {
            this.setState({ activeRowId: rowId });
            document.getElementById('img-action-' + rowId).focus();
        } else if (this.state.activeRowId === rowId) {
            this.setState({ activeRowId: 0 });
        } else if (this.state.activeRowId !== rowId) {
            dropdown = document.getElementById('dropdown-' + this.state.activeRowId);
            dropdownMenu = document.getElementById('dropdown-menu-' + this.state.activeRowId);
            dropdown.classList.toggle('show');
            dropdownMenu.classList.toggle('show');
            this.setState({ activeRowId: rowId });
            document.getElementById('img-action-' + rowId).focus();
        }
    }

    onHideActionButtons = (event, rowId) => {
        let dropdown = document.getElementById('dropdown-' + rowId);
        let dropdownMenu = document.getElementById('dropdown-menu-' + rowId);
        dropdown.classList.remove('show');
        dropdownMenu.classList.remove('show');
        this.setState({ activeRowId: 0 });
    }

    onHandleIsApprovedChange = (e) => {
        let { vehicleInfoValue } = this.state;
        let checked = e.target.checked;
        vehicleInfoValue['is_approved'] = checked;
        this.setState({ vehicleInfoValue: vehicleInfoValue })
    }

    render() {
        let { vehicleFieldsMasterList, toastMessagePop, toastSuccessPop, toastFlagPop, selectedField } = this.state;
        let fieldMasterListActive = vehicleFieldsMasterList.filter(item => item.is_active===true); 
        let fieldId = '';
        let dtVal = '';
        let newDate = new Date();
        let timeZone = getUserTimeZone(this.props.location);
        let userGroupData = userGroupUrlCheck(this.props.location);
        let lblCrew = 'Staff'
        if (userGroupData !== undefined) {
            if (userGroupData.staff_name) {
                lblCrew = userGroupData.staff_name;
            }
        }
        return (
            <div className="col-md-8">
                <Toast toastDescription={toastMessagePop} toastFlag={toastFlagPop} toastSuccess={toastSuccessPop} closeToast={this.onCloseToastPop} />

                <div className="box">
                    <div className="tab-head tdVeticalMiddle">
                        <div className='divFloatLeft padding-left-15 padding-top-5 font-14'><Link to={ROUTE_SA_SETTINGS}>{LBL_BACK_TO_SETTINGS}</Link> </div>
                        <div className="float-right"><button className="btn btn-primary saveBtnMinWidth " onClick={(e) => this.addNewRow(e)} >{LBL_BTN_ADDNEW}</button></div>
                    </div>
                    <div className="box-content">
                        <div className="table-responsive">
                            {this.state.fieldDetails &&
                                <><table id="data-table" className='table dynTable'  >
                                    <thead className="text-bold">
                                        <tr>
                                            <th className="text-center widthPer10">{LBL_SLNUM}</th>
                                            <th className="text-center ">{LBL_FIELD_NAME}</th>
                                            <th className="text-center ">{LBL_FIELD_TYPE}</th>
                                            {/* <th className="text-center ">{stringFormat(LBL_CREW_VISIBILITY, lblCrew)}</th>
                                            <th className="text-center ">{LBL_CLIENT_VISIBILITY}</th> */}
                                            <th className="text-center ">{LBL_MANDATORY_FIELD}</th>
                                            <th className="text-center ">{LBL_ACTIONS}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {fieldMasterListActive.length == 0 && <tr>
                                            <td className="text-center" colSpan={5}>{MSG_NOT_FOUND}</td></tr>}

                                        {fieldMasterListActive.map((fieldObj, fieldIndex) => {
                                            let fieldType = DYNAMIC_FIELDS_TYPES.filter(item => item.value==fieldObj.field_type);

                                            return (
                                                <tr key={fieldObj.field_id}>
                                                    <td className="text-center">{fieldIndex + 1}</td>
                                                    <td className="">{fieldObj.field_name}</td>
                                                    <td className="text-center">{fieldType[0]?.code ? fieldType[0].code : ''}</td>
                                                    {/* <td className="text-center">
                                                        <div className="custom-checkbox">
                                                            <input name={"chk_fieldCrewVisibility_" + fieldObj.field_id} type="checkbox" id={"chk_fieldCrewVisibility_" + fieldObj.field_id} checked={fieldObj.crew_visibility} onChange={(e) => this.onHandleChange(e, fieldObj.field_id, 'crew_visibility')} /> <label className="checkbox" htmlFor={"chk_fieldCrewVisibility_" + fieldObj.field_id}></label>
                                                        </div>
                                                    </td>
                                                    <td className="text-center">
                                                        <div className="custom-checkbox">
                                                            <input name={"chk_fieldClientVisibility_" + fieldObj.field_id} type="checkbox" id={"chk_fieldClientVisibility_" + fieldObj.field_id} checked={fieldObj.client_visibility} onChange={(e) => this.onHandleChange(e, fieldObj.field_id, 'client_visibility')} /> <label className="checkbox" htmlFor={"chk_fieldClientVisibility_" + fieldObj.field_id}></label>
                                                        </div>
                                                    </td> */}
                                                    <td className="text-center">
                                                        {fieldObj.is_mandatory?'Y':'N'}
                                                    </td>
                                                    <td className="text-center">
                                                        <div className="dropdown" id={'dropdown-'+fieldObj.id}>
                                                            <button className="dropdown-toggle" type="button"
                                                                id={'dropdownMenuButton-'+fieldObj.id} data-toggle="dropdown"
                                                                aria-haspopup="true" onClick={(e) => this.onShowActionButtons(e, fieldObj.id)} >
                                                                <input type="image" id={"img-action-"+fieldObj.id} src={require('../../../'+URL_IMG+'action.png')} alt="Action" onBlur={(e) => this.onHideActionButtons(e, fieldObj.id)} ></input>
                                                            </button>
                                                            <div className="dropdown-menu margin-left-40" id={'dropdown-menu-'+fieldObj.id}
                                                                aria-labelledby={'dropdownMenuButton-'+fieldObj.id}>
                                                                <Link className="dropdown-item edit" to="#" onMouseDown={(e) => this.editBtnClick(e, fieldObj.id)}>{LBL_EDIT}</Link>
                                                                <Link className="dropdown-item delete"
                                                                    to="#" onMouseDown={(e)=>this.deleteBtnClick(e,fieldObj.id)}>{LBL_DELETE}</Link> 
                                                            </div>
                                                        </div>
                                                    </td>

                                                </tr>
                                            )  // DYNAMIC_FIELDS_TYPES 
                                        }
                                        )}
                                    </tbody>
                                </table>
                                <div className="col-12 float-right">&nbsp;</div>
                                <div className="col-12 float-right">&nbsp;</div>
                                <div className="col-12 float-right">&nbsp;</div>
                                </>
                            }
                        </div>
                    </div>

                    {/* <div className="tab-head col-12">
                        {this.state.commonErrMsg.length > 0 && (
                            <div className="text-red text-12 text-right">{this.state.commonErrMsg}</div>)}

                        <div className="float-right">
                            <button type="button" className="btn btn-primary saveBtnMinWidth"  >{LBL_SAVE}</button> 
                        </div>     
                    </div>*/}
                </div>

                <ModalWindow ref={this.modalAdd} header={Number(selectedField?.id) > 0 ? LBL_EDIT_VEHICLE_FIELD : LBL_ADD_VEHICLE_FIELD} saveFormData={ (e)=>this.onSaveFormData()} resetModalForm={this.onModalFormReset} type="save"  autoFocusField='skillName'>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-group">
                                <label>{LBL_FIELD_NAME}</label>
                                <div className="text-input">
                                    <input name={"txt_fieldName"} value={selectedField.field_name} onChange={(e) => this.onHandleChange(e, selectedField.id, 'field_name')} maxLength={120} className={selectedField.field_name === '' ? "input-error" : ''} />
                                    {this.state.formErrorFieldName.length > 0 && (
                                    <div className="text-red left-align text-12">{this.state.formErrorFieldName}</div>
                                )}
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group">
                                <label>{LBL_FIELD_TYPE}</label>
                                <div className="form-group multisel_textbox">
                                    <div className="form-group select-input skills" >
                                        <select name={"sel_fieldType"} onChange={(e) => this.onHandleChange(e, selectedField.id, 'field_type')} value={selectedField.field_type} className={selectedField.field_type === '' ? "input-error" : ''} >
                                        <option key={selectedField.id + '_0_0'} value=''>Select</option>
                                        {DYNAMIC_FIELDS_TYPES.map((item, selIndex) => <option key={selectedField.field_id + '_' + selIndex} value={item.value}>{item.code}</option>)}
                                    </select>
                                    </div>
                                </div> 
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-group">
                                <div className="checkbox-wrapper">
                                    <div className="custom-checkbox"><input name="chk_fieldMandatory" type="checkbox" id="chk_fieldMandatory" checked={selectedField.is_mandatory===true?true:false} onChange={(e) => this.onHandleChange(e, selectedField.id, 'is_mandatory')} /><label className="checkbox"htmlFor="chk_fieldMandatory"></label><label className="labeltext"htmlFor="chk_fieldMandatory">{LBL_MANDATORY_FIELD}</label></div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            &nbsp;
                        </div>
                    </div> 
                    {/* <div className="row">
                        <div className="col-md-6">
                            <div className="form-group">
                                <div className="checkbox-wrapper">
                                    <div className="custom-checkbox">
                                        <input name="showDateRange" type="checkbox" id="showDateRange" checked={skillData.showDateRange ? true : false} onChange={this.onHandleChange} />
                                        <label className="checkbox"htmlFor="showDateRange"></label>
                                        <label className="labeltext"htmlFor="showDateRange">{LBL_SHOW_DATE_RANGE}</label>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> */}
                    
                </ModalWindow>  

                <ModalWindow ref={this.modalDelete} header={LBL_CONFIRM_DELETE} type="delete" deleteItem={this.onDeleteAction} resetModalForm={this.onModalFormReset}>
                    {stringFormat(MSG_DELETE_VECHICLE_FIELD,"'"+selectedField.field_name+"'")}
                </ModalWindow>
                
            </div>

        )
    }
}

const mapStateToProps = (state) => {
    // console.log('state.vehicleMasterInfo.vehicleFieldsMasterList: ',state.vehicleMasterInfo.vehicleFieldsMasterList); 
    return {
        vehicleFieldsMasterList: state.vehicleMasterInfo.vehicleFieldsMasterList,
        vehicleFieldsMasterStatus: state.vehicleMasterInfo.vehicleFieldsMasterStatus,
        vehicleFieldsMasterActivity: state.vehicleMasterInfo.vehicleFieldsMasterActivity,
        vehicleFieldsMasterSavedList: state.vehicleMasterInfo.vehicleFieldsMasterSavedList,
        vehicleFieldsMasterErrorData: state.vehicleMasterInfo.vehicleFieldsMasterErrorData
    }
} 

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        listVehicleFieldsMasterAction: listVehicleFieldsMasterAction,
        addVehicleFieldaMasterAction: addVehicleFieldaMasterAction,
        updateVehicleFieldaMasterAction: updateVehicleFieldaMasterAction,
        deleteVehicleFieldaMasterAction: deleteVehicleFieldaMasterAction,
        clearAction: clearAction
    }, dispatch);
}
export default connect(mapStateToProps, mapDispatchToProps)(VehicleMasterFields);
